import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
const specialties = [{
  title: "Premium Rice",
  technical: "Premium Sona Masoori & Basmati",
  description: "Sourced directly from the finest agricultural hubs in India.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578090/img/premium_rice_harvest.png",
  link: "/ProductsPage"
}, {
  title: "Regional Spices",
  technical: "Authentic Mirchi & Blends",
  description: "Warm, aromatic spice tones reflecting our natural product lines.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578090/img/authentic_mirchi_spices.png",
  link: "/ProductsPage"
}, {
  title: "Eco-Products",
  technical: "Biodegradable Plant-Based",
  description: "Dedicated line of eco-friendly paper plates and cutlery.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578090/img/eco_friendly_plates.png",
  link: "/ProductsPage"
}];
export default function OurGlobalSpecialties() {
  return <section id="our-global-specialties" className="py-24 bg-background relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground tracking-tight mb-6">
            Our Global Specialties
          </h2>
          <p className="text-lg text-muted-foreground">
            Facilitating high-quality global trade between the USA and India. We bridge the gap with premium sourcing connections to major agricultural and commercial hubs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {specialties.map((item, i) => <div data-index={i} key={i} className="h-full">
              <Link to={item.link} className="group block relative h-[450px] lg:h-[550px] w-full overflow-hidden rounded-3xl bg-muted shadow-lg transition-shadow hover:shadow-xl">
                {}
                <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-out saturate-50 group-hover:saturate-100 group-hover:scale-[1.02]" />

                {}
                <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-transparent opacity-60" />

                {}
                <div className="absolute top-0 left-0 w-full p-8 transition-transform duration-500 ease-out group-hover:-translate-y-4 group-hover:opacity-0">
                  <h3 className="text-2xl font-bold text-white tracking-wide drop-shadow-md">
                    {item.title}
                  </h3>
                </div>

                {}
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/95 via-secondary/60 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 ease-out translate-y-12 group-hover:translate-y-0" />

                {}
                <div className="absolute bottom-0 left-0 w-full p-8 flex flex-col justify-end opacity-0 group-hover:opacity-100 transition-all duration-500 ease-out translate-y-8 group-hover:translate-y-0 delay-75">
                  <p className="text-white/90 text-sm font-medium uppercase tracking-wider mb-2">
                    {item.title}
                  </p>
                  <h4 className="text-2xl lg:text-3xl font-bold text-white mb-3 leading-tight">
                    {item.technical}
                  </h4>
                  <p className="text-white/80 text-sm mb-6 line-clamp-2">
                    {item.description}
                  </p>
                  
                  <div className="inline-flex items-center text-white font-semibold text-sm group/btn">
                    Explore Category
                    <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                  </div>
                </div>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}